import { zh } from './zh'
import { en } from './en'
import { useAppStore } from '../stores/appStore'

export { zh, en }

export const useI18n = () => {
  const lang = useAppStore((state) => state.currentLanguage)
  return lang === 'zh' ? zh : en
}
